import styles from '../../HomepageSections.module.scss';

export const StageIcon = ({ type }: { type: string }) => {
  if (type === 'erp') {
    return (
      <svg viewBox='0 0 30 30' aria-hidden='true'>
        <ellipse cx='15' cy='7' rx='10' ry='4' />
        <path d='M5 7v16c0 2.2 4.5 4 10 4s10-1.8 10-4V7' />
        <path className={styles.accentStroke} d='M5 15c0 2.2 4.5 4 10 4s10-1.8 10-4' />
      </svg>
    );
  }

  if (type === 'invoice') {
    return (
      <svg viewBox='0 0 30 30' aria-hidden='true'>
        <path d='M8 3h10l6 6v18H8zM18 3v6h6' />
        <path className={styles.accentStroke} d='M12 15h8M12 20h6' />
        <path className={styles.mutedStroke} d='m4.5 11-2 2 2 2M27.5 15l2 2-2 2' />
      </svg>
    );
  }

  if (type === 'validation') {
    return (
      <svg viewBox='0 0 30 30' aria-hidden='true'>
        <path className={styles.accentStroke} d='M15 2l11 4v8c0 6.5-4.5 11.5-11 14C8.5 25.5 4 20.5 4 14V6z' />
        <path className={`${styles.lightStroke} ${styles.validationCheck}`} d='m10 14.5 3.5 3.5 6.5-7.5' />
      </svg>
    );
  }

  if (type === 'format') {
    return (
      <svg viewBox='0 0 30 30' aria-hidden='true'>
        <path d='M6 3h12l6 6v18H6z' />
        <rect className={styles.formatQr} x='10' y='13' width='7' height='7' />
        <path className={styles.formatQrGrid} d='M11.8 14.8h3.4M11.8 17.2h3.4M13.5 13v7' />
        <path className={styles.formatSignature} d='M20.5 23.5c2.5 0 2.5-3.5 0-3.5' />
      </svg>
    );
  }

  return (
    <svg viewBox='0 0 30 30' aria-hidden='true'>
      <path d='m4 12 11-8 11 8' />
      <path className={styles.authorityColumns} d='M7.5 14v10M13 14v10M18.5 14v10M24 14v10' />
      <path d='M4 26.5h22' />
      <circle className={styles.authoritySeal} cx='24' cy='7' r='5' />
      <path className={styles.authorityCheck} d='m22 7 1.5 1.5 2.7-2.9' />
    </svg>
  );
};
